<template>
  <div class="signup-enter-code">
    <riseup-header/>
    <cookies-disabled-error v-if="cookiesDisabledError" class="error-holder" />
    <signup-member-already-exists-error v-else-if="memberAlreadyExists" :phoneNumber="phoneNumber" />
    <div v-else>
      <div class="content">
        <enter-code class="enter-code"
                    :first-name="firstName"
                    :phone-number="phoneNumber"
                    :confirm-code-action="authenticateAndProceed"
                    :regenerate-code-action="forceGenerateCode"
                    :server-error="serverErrors.authenticate"
                    :button-title="'אישור'"
                    :loading="loading"
                    :reset-error="() => resetError('authenticate')"/>
        <login-support-footer :link-action="openLoginHelpModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import SignupMemberAlreadyExistsError
  from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/SignupMemberAlreadyExistsError';
import Segment from '@/Segment';
import EnterCode from '@/base-components/EnterCode.vue';
import CookiesDisabledError from '@/pages/general-errors/CookiesDisabledError.vue';
import BaseUI from 'base-ui';
import ModalBus from '@/event-bus/modal-bus';
import LoginHelp from '@/pages/responsive-pages/non-authenticated/login/steps/LoginHelp';
import RiseupHeader from '@/base-components/app-header/RiseupHeader';

export default {
  name: 'SignupEnterCode',
  components: {
    RiseupHeader,
    SignupMemberAlreadyExistsError,
    EnterCode,
    CookiesDisabledError,
    LoginSupportFooter: BaseUI.LoginSupportFooter,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('SignupCodeEntered');
  },
  computed: {
    ...mapState('signup', ['firstName', 'lastName', 'phoneNumber', 'serverErrors', 'createdCustomerId']),
    ...mapGetters('signup', ['errorTypes', 'amplitudeUtmParams']),
    ...mapState('promotions', ['promotion']),
    ...mapGetters('promotions', ['isPromotionEligible']),
    memberAlreadyExists() {
      return this.serverErrors.createCustomer === this.errorTypes.memberAlreadyExists;
    },
    cookiesDisabledError() {
      return this.serverErrors.authenticate === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapActions('signup', ['authenticate', 'createCustomer', 'forceGenerateCode']),
    ...mapMutations('signup', ['resetError']),
    ...mapActions('session', ['init']),
    async authenticateAndProceed(code) {
      Segment.trackUserInteraction('CodeEnteredClicked');
      Segment.trackUserInteractionToPixel('CodeEnteredClicked');
      this.loading = true;
      try {
        await this.authenticate(code);
        if (!this.serverErrors.authenticate) {
          await this.createCustomerAndSession();
          this.next();
        } else if (this.memberAlreadyExists) {
          Segment.trackUserGot('SignupEnterCode_MemberAlreadyExists');
        } else if (this.cookiesDisabledError) {
          Segment.trackUserGot('SignupEnterCode_CookiesDisabledError');
        }
      } finally {
        this.loading = false;
      }
    },
    async identifyCustomer(customerId) {
      Segment.identifyCustomer(customerId, {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
        promotion: this.promotion && this.isPromotionEligible ? this.promotion : null,
        ...this.amplitudeUtmParams,
      });
    },
    async createCustomerAndSession() {
      await this.createCustomer();
      await this.identifyCustomer(this.createdCustomerId);
      Segment.trackUserGotToPixel('CCC');
      await this.init({});
    },
    openLoginHelpModal() {
      ModalBus.$emit('open', {
        component: LoginHelp,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  @import 'src/scss/mixins';

  .error-holder {
    margin: 30px;
  }

  .signup-enter-code {
    width: 100%;

    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }

    .enter-code {
      @include responsive-padding;
      width: 100%;
    }
  }

</style>
